import React, { Component } from "react"
import PropTypes from "prop-types"
import { ThemeProvider } from "styled-components"
import 'scss/main.scss'
import SEO from "components/Seo/Seo"
import GlobalStyles from "utils/GlobalStyles";
import theme from "utils/Theme"

class LayoutInteractive extends Component {
	componentDidMount() {
		this.tealiumTracking()

		window.addEventListener('keydown', this.handleFirstTab);
	}

	handleFirstTab(e) {
		if (e.keyCode === 9) { // the "I am a keyboard user" key
			document.body.classList.add('user-is-tabbing');
			window.removeEventListener('keydown', this.handleFirstTab);
		}
	}

	tealiumTracking() {
		var pageData = {
			siteName: "lkeducation",
			country: "uk",
			region: "emea",
			page_name: this.props.title
		};

		if (window !== 'undefined' && window.utag) {
			window.utag.view(pageData)
		}
	}

	render() {
		const {title, slug} = this.props
		return(
			<ThemeProvider theme={theme}>
				<div>
					<SEO
						title={title}
						description={"The official website for Disney’s THE LION KING Education Programme, where you will find comprehensive resources for all age groups available to download and enjoy."}
						keywords={[`Lion King Education`, `Lion King`]}
						slug={slug}
					/>
					<GlobalStyles />
					<noscript className="no-js">Javascript is required to view the full experience of this site.</noscript>

					<main className="main">{this.props.children}</main>
					{/* <Footer /> */}
				</div>
			</ThemeProvider>
		)
	}
}

LayoutInteractive.propTypes = {
    children: PropTypes.node.isRequired,
}

LayoutInteractive.defaultProps = {
	data: {
		metaDescription: "",
		metaTitle: "Lion King Education",
	},
};

export default LayoutInteractive